import { Chart, ChartKey } from '@frontend/chart/types';

import { getChartCatalogEntry } from '../catalog/chart-catalog';
import { ChartRendererProps } from '../types/chart-renderer-props';

export interface ChartPreviewProps extends Omit<ChartRendererProps, 'data'> {
    chartKey: ChartKey | string;
    data?: Chart;
}

export const ChartPreview = ({ chartKey, data, ...rendererProps }: ChartPreviewProps) => {
    const entry = getChartCatalogEntry(chartKey);

    if (!entry) {
        return null;
    }

    const { Component, mockData } = entry;

    return (
        <Component
            data={data ?? mockData}
            {...rendererProps}
        />
    );
};
